/*
  used in snippets/cart-drawer.liquid (snippets/ccustomDailyDealLiquid.liquid)

  "Päivän löytö" -lohkon sulkupainike. Piilotus kestää vain istunnon
  (sessionStorage). Avain on muotoa daily-pick-dismissed:<tuotteen id>, joten
  lohko palaa näkyviin kun kaupan omistaja vaihtaa tuotetta.

  Jos sessionStorage ei ole käytettävissä (yksityinen selaus, estetyt
  evästeet), lohko näkyy normaalisti ja sulkeminen toimii vain sivun ajan.
*/

if (!customElements.get('ccustom-daily-deal')) {
  const dismissStorage = {
    get(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        // Ei tallennusta: lohko piilotetaan silti tämän sivun ajaksi
      }
    },
  };

  customElements.define(
    'ccustom-daily-deal',
    class CcustomDailyDeal extends HTMLElement {
      connectedCallback() {
        // Ostoskori renderöidään uudelleen joka muutoksella, joten tarkistus
        // tehdään aina kun elementti lisätään sivulle
        if (this.dataset.dismissKey && dismissStorage.get(this.dataset.dismissKey) === '1') {
          this.hidden = true;
          return;
        }

        const button = this.querySelector('.ccustom-daily-deal__dismiss');
        if (button) button.addEventListener('click', () => this.dismiss(button), { once: true });
      }

      dismiss(button) {
        const hadFocus = document.activeElement === button;

        if (this.dataset.dismissKey) dismissStorage.set(this.dataset.dismissKey, '1');
        this.hidden = true;

        // Näppäimistökäyttäjän fokus ei saa kadota piilotetun lohkon mukana
        if (hadFocus) {
          const footer = this.closest('.drawer__footer');
          const next = footer && footer.querySelector('summary, #CartDrawer-Checkout');
          if (next) next.focus();
        }
      }
    }
  );
}
